<template>
  <div>
    <h4 class="text-center mb-5">Application Home</h4>
    <!-- Desktop and large device text -->
    <div class="desktop-text">
      <p>Welcome to the Trailfinders Application Portal. Please read the following guidance</p>
      <ul>
        <li v-for="(text, index) in instructionsDesk" :key="'desktop-instruction-' + index">{{ text }}</li>
      </ul>
    </div>
    <!-- Mobile and small device text -->
    <div class="mobile-text">
      <p>Welcome to the Trailfinders Application Portal. Thank you for registering. Please ensure you read through the guidance below.</p>
      <ul>
        <li v-for="(text, index) in instructionsMobile" :key="'mobile-instruction-' + index">{{ text }}</li>
      </ul>
    </div>
    <p class="mt-2">Once you have submitted your application you will receive an email from the Recruitment team within a few days.</p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      instructionsDesk: [
        'Please complete each section of the form using the menu on the left',
        'You can save your progress and logout, then return later if required',
        'You will find the save button on the menu on the left and at the bottom of each section',
        'Please check all your details carefully and press Submit Application once complete',
        'Once you have submitted your application you will be unable to return to make updates'
      ],
      instructionsMobile: [
        'Please complete each section of the form by clicking on the icons at the top',
        'You can save your progress and logout, then return later if required',
        'You will find the save button on the menu bar at the top of each section and under the content of each section',
        'Please check all your details carefully and press Submit Application once complete',
        'Once you have submitted your application you will be unable to return to make updates'
      ]
    }
  }
}
</script>

<style scoped>

</style>